import { Button, Upload, Modal, Input, message } from "antd";
import React, { useEffect, useState } from "react";
import {
  UploadOutlined,
  PlusOutlined,
  DeleteOutlined,
} from "@ant-design/icons";
import { useLocation, useNavigate } from "react-router-dom";
import api from "../Interceptor";
import { getRoute } from "../api/routes";
import { toast } from "react-toastify";
import axios from "axios";
import { CustomInput, CustomSelect, ErrorText } from "../components/ui";
import CustomModal from "../components/customModal/customModal";
import ModalFooter from "../components/customModal/modalFooter";
import { DatePicker } from "antd";
import dayjs from "dayjs";
import {
  validateFormHandler,
  validateLiveField,
} from "../utils/validations/validateForm";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
const CreateInvoice = () => {
  const location = useLocation();
  const { invoiceCount } = location.state || { invoiceCount: 0 };
  const [currencies, setCurrencies] = useState([]);
  const [saveLoader, setSaveLoader] = useState(false);
  const [currency, setCurrency] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [customerCompany, setCustomerCompany] = useState("");
  const [note, setNote] = useState("");
  const [date, setDate] = useState(dayjs());
  const [discount, setDiscount] = useState(0);
  // const [signature, setSignature] = useState(null);
  const [isTaxModalVisible, setIsTaxModalVisible] = useState(false);
  const [taxList, setTaxList] = useState([]);
  const [taxName, setTaxName] = useState("");
  const [taxRate, setTaxRate] = useState("");
  const [isItemModalVisible, setIsItemModalVisible] = useState(false);
  const [itemList, setItemList] = useState([]);
  const [itemName, setItemName] = useState("");
  const [itemQuantity, setItemQuantity] = useState("");
  const [AllItemQuantity, setAllItemQuantity] = useState("");
  const [itemUnitPrice, setItemUnitPrice] = useState("");
  const [itemTotalPrice, setItemTotalPrice] = useState("");
  const [allItemTotalPrice, setAllItemTotalPrice] = useState("");
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  // const handleFileChange = (info) => {
  //   const file = info.fileList[info.fileList.length - 1]?.originFileObj;
  //   setSignature(file);
  // };

  const handleAddTax = () => {
    if (!taxName || !taxRate) {
      message.warning("Please fill in both Tax Name and Tax Rate.");
      return;
    }

    setTaxList((prevTaxList) => [
      ...prevTaxList,
      { name: taxName, rate: parseFloat(taxRate) },
    ]);

    setTaxName("");
    setTaxRate("");
  };

  const handleDeleteTax = (index) => {
    setTaxList((prevTaxList) => prevTaxList.filter((_, i) => i !== index));
  };

  const handleAddItem = () => {
    if (!itemName || !itemQuantity || !itemUnitPrice) {
      message.warning("Please fill in all fields.");
      return;
    }

    const totalItemPrice = itemQuantity * itemUnitPrice;
    setItemList([
      ...itemList,
      {
        itemName: itemName,
        itemQuantity: itemQuantity,
        itemUnitPrice: itemUnitPrice,
        itemTotalPrice: totalItemPrice,
      },
    ]);
    setItemName("");
    setItemQuantity("");
    setItemUnitPrice("");
    setItemTotalPrice("");
    calculateTotalItems();
    calculateTotalAllItems();
  };

  const handleDeleteItem = (index) => {
    setItemList(itemList.filter((_, i) => i !== index));
  };

  // const uploadImage = async (image) => {
  //   const data = new FormData();
  //   data.append('file', image);
  //   data.append('upload_preset', 'ExpenseTracker');
  //   try {
  //     const response = await fetch(
  //       'https://api.cloudinary.com/v1_1/dqvgbgje8/image/upload',
  //       {
  //         method: 'POST',
  //         body: data,
  //       }
  //     );
  //     const urlData = await response.json();
  //     return urlData.url;
  //   } catch (error) {
  //     console.error(error);
  //     message.error('Image upload failed.');
  //     return null;
  //   }
  // };
  const handleNameChange = (e) => {
    const value = e.target.value;
    setCustomerName(value);

    const error = validateLiveField("customerName", value);

    setErrors((prev) => ({ ...prev, customerName: error || undefined }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validateFormHandler({
      customerName,
      date,
      currency,
      // signature,
      item: itemList.length === 0 ? "" : itemList.length.toString(),
    });
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      return;
    }
    setSaveLoader(true);
    if (!customerName || itemList.length === 0 || !date) {
      message.warning(
        "Please fill in all required fields and add at least one item and tax."
      );
      setSaveLoader(false);
      return;
    }

    // let signatureUrl = null;
    // if (signature) {
    //   signatureUrl = await uploadImage(signature);
    //   if (!signatureUrl) {
    //     message.error('Failed to upload signature. Please try again.');
    //     setSaveLoader(false);
    //     return;
    //   }
    // } else {
    //   signatureUrl = '';
    // }

    const payload = {
      number: invoiceCount + 1,
      customerName,
      customerCompany: customerCompany || undefined,
      note: note || undefined,
      date,
      discount: discount || undefined,
      // signature: signatureUrl,
      currency,
      items: itemList.map((item) => ({
        name: item.itemName,
        quantity: item.itemQuantity,
        unitPrice: item.itemUnitPrice,
      })),
      taxes: [...taxList],
    };

    try {
      const endpoint = getRoute("users", "admin", "invoices", false, true);
      const response = await api.post(endpoint, payload);

      if (response.status === 201) {
        toast.success("Invoice created successfully!");
        setTimeout(() => {
          setCustomerName("");
          setCustomerCompany("");
          setNote("");
          setDate("");
          setDiscount("");
          // setSignature(null);
          setTaxList([]);
          setItemList([]);
          setCurrency("");
          navigate("/invoices");
        }, 100);
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.message ||
        "Failed to create invoice. Please try again.";
      toast.error(errorMessage);
    } finally {
      setSaveLoader(false);
    }
  };

  const calculateItemTotalPrice = () => {
    const totalPrice = itemQuantity * itemUnitPrice;
    setItemTotalPrice(totalPrice);
  };

  const calculateTotalItems = () => {
    const totalItems = itemList.reduce((acc, item) => {
      return acc + Number(item.itemQuantity || 0);
    }, 0);
    setAllItemQuantity(totalItems);
  };

  const calculateTotalAllItems = () => {
    const totalPrice = itemList.reduce((acc, item) => {
      return acc + item.itemQuantity * item.itemUnitPrice;
    }, 0);
    const taxTotal = taxList.reduce((acc, tax) => {
      return acc + (totalPrice * parseFloat(tax.rate)) / 100;
    }, 0);
    setAllItemTotalPrice(totalPrice + taxTotal);
  };
  useEffect(() => {
    calculateTotalItems();
    calculateTotalAllItems();
  }, [itemList]);

  useEffect(() => {
    const getAllCurrencies = async () => {
      try {
        const { data: currencyData } = await axios.get(
          `${API_BASE_URL}/api/v1/getAllCurrencies`
        );
        setCurrencies(currencyData);
      } catch (error) {
        if (error?.isUnpaid) {
          return;
        }
        toast.error("Oops! Error while fetching Currencies");
      }
    };
    getAllCurrencies();
  }, []);
  const resetItemFields = () => {
    setItemName("");
    setItemQuantity("");
    setItemUnitPrice("");
  };
  const resetTaxFields = () => {
    setTaxName("");
    setTaxRate("");
  };
  return (
    <div className="min-h-screen bg-white lg:max-h-screen flex flex-col p-3 gap-2 overflow-hidden font-customFont">
      <div className="flex flex-col md:flex-row justify-between items-start md:items-center mb-6">
        <div style={{ fontFamily: "Roboto, sans-serif" }}>
          <h1 className="font-bold text-lg md:text-xl">Create New Invoice</h1>
        </div>
      </div>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div>
            <div className="mb-4">
              <CustomInput
                type="text"
                value={customerName}
                label=" Customer Name"
                // required
                // onChange={(e) => setCustomerName(e.target.value)}
                onChange={handleNameChange}
                message={errors.customerName}
                requir="true"
              />
            </div>

            <div className="mb-4">
              <CustomInput
                type="text"
                label="Customer Company"
                value={customerCompany}
                onChange={(e) => setCustomerCompany(e.target.value)}
              />
            </div>

            <div className="mb-4">
              <label
                htmlFor="date"
                className="block font-medium mb-1 text-gray-700"
              >
                Date <span className="text-red-500">*</span>
              </label>
              <DatePicker
                id="date"
                name="date"
                className="w-full h-[43px] rounded-md border border-gray-300 shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                value={date ? dayjs(date) : null}
                defaultValue={date}
                onChange={(value) => {
                  const selectedDate = value ? value.format("YYYY-MM-DD") : "";
                  setDate(selectedDate);
                  if (errors.date) {
                    setErrors((prev) => ({ ...prev, date: undefined }));
                  }
                }}
              />
              {errors.date && (
                <p className="text-red-500 text-sm mt-1">{errors.date}</p>
              )}
            </div>
            <div className="mb-4">
              <CustomInput
                type="number"
                label="Discount(%)"
                value={discount}
                onChange={(e) => setDiscount(e.target.value)}
                //  onChange={(e) => {
                //     setDiscount(e.target.value);
                //     if (errors.discount) {
                //       setErrors((prev) => ({ ...prev, discount: undefined }));
                //     }
                //   }}
                // message={errors.discount}
              />
            </div>
            {/* <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Signature <span className="text-red-500">*</span>
                <Upload
                  listType="picture"
                  required
                  beforeUpload={() => false}
                  // onChange={handleFileChange}
                  onChange={(value) => {
                    handleFileChange(value);
                    if (errors.signature) {
                      setErrors((prev) => ({ ...prev, signature: undefined }));
                    }
                  }}
                  className="mt-1 block w-full py-0 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                >
                  <Button
                    icon={<UploadOutlined />}
                    className="mb-1 bg-transparent border-0 hover:!text-themeColor hover:!bg-transparent hover:text-themeColor2 focus:outline-none"
                  >
                    Upload Image
                  </Button>
                </Upload>
                { errors.signature && <span>{errors.signature}</span>}
                {errors.signature && <ErrorText message={errors.signature} />}
              </label>
            </div>  */}
          </div>

          <div>
            <div className="mb-4">
              <CustomSelect
                label="Currency"
                value={currency}
                // onChange={setCurrency}
                options={currencies.map((currency) => ({
                  label: `${currency.symbol} ${currency.name}`,
                  value: currency._id,
                }))}
                onChange={(value) => {
                  setCurrency(value);
                  if (errors.currency) {
                    setErrors((prev) => ({ ...prev, currency: undefined }));
                  }
                }}
                message={errors.currency}
                requir="true"
              />
            </div>
            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Items <span className="text-red-500">*</span>
                <div
                  onClick={() => setIsItemModalVisible(true)}
                  icon={<PlusOutlined />}
                  className="mt-1 block w-full px-3 py-2 text-center border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                >
                  Add Item
                </div>
              </label>

              <div className="mt-4">
                <div className="flex justify-between items-center">
                  <span className="font-semibold">Total Items:</span>
                  <span>{parseFloat(AllItemQuantity).toFixed(2)}</span>
                </div>

                <div className="flex justify-between items-center mt-2 font-bold">
                  <span>Total Amount:</span>
                  <span>{parseFloat(allItemTotalPrice).toFixed(2)}</span>
                </div>
              </div>
            </div>
            {allItemTotalPrice == 0 && <ErrorText message={errors.item} />}

            <div className="mb-4">
              <label className="block text-gray-700 mb-2">
                Tax
                <div
                  onClick={() => setIsTaxModalVisible(true)}
                  icon={<PlusOutlined />}
                  className="mt-1 block w-full px-3 py-2 text-center border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-themeColor focus:border-themeColor"
                >
                  Add Tax
                </div>
              </label>
              <ul className="mt-2">
                {taxList.length > 0 &&
                  taxList.map((tax, index) => (
                    <li
                      key={index}
                      className="flex justify-between items-center"
                    >
                      {tax.name} - {tax.rate}%
                      <Button
                        type="link"
                        icon={<DeleteOutlined />}
                        onClick={() => handleDeleteTax(index)}
                        className="text-red-500"
                      />
                    </li>
                  ))}
              </ul>

              <div className="mt-4">
                <div className="flex justify-between items-center">
                  <span className="font-semibold">Subtotal:</span>
                  <span>
                    {allItemTotalPrice
                      ? parseFloat(allItemTotalPrice)
                          .toFixed(2)
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "0.00"}
                  </span>
                </div>

                {taxList.map((tax, index) => {
                  const taxValue = (
                    (parseFloat(itemTotalPrice) * parseFloat(tax.rate)) /
                    100
                  ).toFixed(2);
                  return (
                    <div
                      key={index}
                      className="flex justify-between items-center"
                    >
                      <span className="font-semibold">
                        {tax.name} ({tax.rate}%):
                      </span>
                      <span>{taxValue}</span>
                    </div>
                  );
                })}

                <div className="flex justify-between items-center mt-2 font-bold">
                  <span>Total:</span>
                  <span>
                    {allItemTotalPrice && !isNaN(parseFloat(allItemTotalPrice))
                      ? (
                          parseFloat(allItemTotalPrice) +
                          taxList.reduce((acc, tax) => {
                            return (
                              acc +
                              (parseFloat(allItemTotalPrice) *
                                parseFloat(tax.rate)) /
                                100
                            );
                          }, 0)
                        )
                          .toFixed(2)
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                      : "0.00"}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mb-4">
          <CustomInput
            label="Note"
            id="note"
            as="textarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            //  onChange={(e) => {
            //   setNote(e.target.value);
            //   if (errors.note) {
            //     setErrors((prev) => ({ ...prev, note: undefined }));
            //   }
            // }}
            // message={errors.note}
            rows="4"
          />
        </div>

        <div className="text-center mt-10">
          <button
            type="submit"
            disabled={saveLoader}
            className={`py-2 px-6 w-40 bg-themeGradient text-white font-semibold rounded-md shadow-sm hover:bg-themeColor2  ${
              saveLoader ? "cursor-not-allowed opacity-50" : ""
            }`}
          >
            {saveLoader ? "Creating..." : "Create"}
          </button>
        </div>
      </form>

      <CustomModal
        modalTitle="Add Tax"
        isOpen={isTaxModalVisible}
        onClose={() => {
          setIsTaxModalVisible(false);
          resetTaxFields();
        }}
      >
        <div className="mt-1 mb-3">
          <CustomInput
            placeholder="Tax Name"
            value={taxName}
            onChange={(e) => setTaxName(e.target.value)}
          />
          <CustomInput
            type="number"
            placeholder="Tax Rate (%)"
            value={taxRate}
            onChange={(e) => setTaxRate(e.target.value)}
            min="0"
            step="0.01"
          />
        </div>
        <ModalFooter
          onCancel={() => {
            setIsTaxModalVisible(false);
            resetTaxFields();
          }}
          onSave={() => {
            handleAddTax();
            setIsTaxModalVisible(false);
            resetTaxFields();
          }}
        />

        {taxList.length > 0 && (
          <ul className="mt-4">
            {taxList.map((tax, index) => (
              <li
                key={index}
                className="flex justify-between items-center mb-2"
              >
                {tax.name} - {tax.rate}%
                <Button
                  type="link"
                  icon={<DeleteOutlined />}
                  onClick={() => handleDeleteTax(index)}
                  className="text-red-500"
                />
              </li>
            ))}
          </ul>
        )}
      </CustomModal>

      <CustomModal
        modalTitle="Add Item"
        isOpen={isItemModalVisible}
        onClose={() => {
          setIsItemModalVisible(false);
          resetItemFields();
        }}
      >
        <form>
          <div className="mt-1 mb-3">
            <CustomInput
              placeholder="Item Name"
              value={itemName}
              onChange={(e) => setItemName(e.target.value)}
            />
            <CustomInput
              type="number"
              placeholder="Quantity"
              value={itemQuantity}
              onChange={(e) => setItemQuantity(e.target.value)}
            />
            <CustomInput
              type="number"
              placeholder="Unit Price"
              value={itemUnitPrice}
              onChange={(e) => setItemUnitPrice(e.target.value)}
            />
            <CustomInput
              type="number"
              value={itemUnitPrice * itemQuantity || 0}
              disabled
              label="Total Amount"
              className="text-gray-400"
            />
          </div>
          <ModalFooter
            onCancel={() => {
              setIsItemModalVisible(false);
              resetItemFields();
            }}
            onSave={() => {
              handleAddItem();
              calculateItemTotalPrice();
              setIsItemModalVisible(false);
              resetItemFields();
            }}
          />

          {/* Item List */}
          {itemList.length > 0 && (
            <ul className="mt-4">
              {itemList.map((item, index) => (
                <li
                  key={index}
                  className="flex justify-between items-center mb-2"
                >
                  {item.itemName} - {item.itemQuantity} - {item.itemUnitPrice} -{" "}
                  {item.itemTotalPrice}
                  <Button
                    type="link"
                    icon={<DeleteOutlined />}
                    onClick={() => handleDeleteItem(index)}
                    className="text-red-500"
                  />
                </li>
              ))}
            </ul>
          )}
        </form>
      </CustomModal>
    </div>
  );
};

export default CreateInvoice;
